import type { App } from '../app/App';
import type { GameSceneOptions } from '../game/scene/GameSceneOptions';

export function startNewLevel(app: App, options: GameSceneOptions): void {
  const { controller } = app;
  controller.launchGameScene(options);
}
